var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotification(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    rx: 4,
    fill: "#87888B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.8333 6.2915C18.7977 6.2915 17.9583 7.13097 17.9583 8.1665C17.9583 9.20204 18.7977 10.0415 19.8333 10.0415C20.8688 10.0415 21.7083 9.20204 21.7083 8.1665C21.7083 7.13097 20.8688 6.2915 19.8333 6.2915ZM16.7083 8.1665C16.7083 6.44061 18.1074 5.0415 19.8333 5.0415C21.5591 5.0415 22.9583 6.44061 22.9583 8.1665C22.9583 9.89239 21.5591 11.2915 19.8333 11.2915C18.1074 11.2915 16.7083 9.89239 16.7083 8.1665Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.04163 13.9998C5.04163 9.05466 9.05478 5.0415 14 5.0415C14.6178 5.0415 15.2166 5.10424 15.8041 5.21995C16.1427 5.28666 16.3632 5.61529 16.2965 5.95396C16.2298 6.29263 15.9012 6.5131 15.5625 6.44639C15.05 6.34543 14.5321 6.2915 14 6.2915C9.74514 6.2915 6.29163 9.74502 6.29163 13.9998C6.29163 18.2547 9.74514 21.7082 14 21.7082C18.2548 21.7082 21.7083 18.2547 21.7083 13.9998C21.7083 13.4758 21.6543 12.9591 21.5541 12.4659C21.4854 12.1276 21.7039 11.7977 22.0422 11.729C22.3805 11.6603 22.7104 11.8788 22.7791 12.2171C22.8956 12.7906 22.9583 13.3906 22.9583 13.9998C22.9583 18.945 18.9451 22.9582 14 22.9582C9.05478 22.9582 5.04163 18.945 5.04163 13.9998Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotification);
export default __webpack_public_path__ + "static/media/notification.52d8ba4990ff239af05521397b01e13e.svg";
export { ForwardRef as ReactComponent };